import { motion } from 'framer-motion';
import './ContactCTA.css';

const ContactCTA = ({ onOpenModal }) => {
    return (
        <section className="contact-cta-section">
            <div className="container">
                <motion.div
                    className="cta-content"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                >
                    <h2 className="cta-title">Ready to Start Your Project?</h2>
                    <p className="cta-description">
                        Let's discuss your architectural vision and bring it to life.
                        Our team is ready to help you create something extraordinary.
                    </p>
                    <motion.button
                        className="cta-button"
                        onClick={onOpenModal}
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                    >
                        <i className="bi bi-envelope-fill"></i>
                        Contact Us
                    </motion.button>
                </motion.div>
            </div>
        </section>
    );
};

export default ContactCTA;
